import React, { useEffect } from "react";
import { Modal, message } from "antd";
import MappingForm from "./MappingForm"; // The form for creating/editing mappings
import axios from "axios";
import { CREATE_MAPPING, UPDATE_MAPPING } from "../../util";

const MappingModal = ({
  isVisible,
  onClose,
  editMapping,
  connectionId,
  fetchMappings,
  fetchData,
}) => {
  const handleSubmit = async (values) => {
    if (editMapping) {
      // Update mapping if editMapping exists
      await axios.put(`${UPDATE_MAPPING}/${editMapping?.id}`, values);
      message.success("Mapping updated successfully!");
      fetchMappings(connectionId?.id);
      fetchData();
    } else {
      // Create new mapping
      await axios.post(CREATE_MAPPING, {
        ...values,
        connectionId: connectionId.id,
      });
      fetchMappings(connectionId.id);
      fetchData();
      message.success("Mapping created successfully!");
    }
    onClose(); // Close the modal after submission
  };

  // Determine the next order value
  const getNextOrderValue = () => {
    if (
      connectionId &&
      connectionId?.mapping &&
      connectionId?.mapping?.length > 0
    ) {
      const lastMapping =
        connectionId?.mapping[connectionId?.mapping?.length - 1];
      return lastMapping?.order + 1; // Set next order to last item's order + 1
    }
    return 1; // Default to 1 if no mappings exist
  };

  return (
    <Modal
      title={editMapping ? "Edit Mapping" : "Create Mapping"}
      open={isVisible}
      onCancel={onClose}
      footer={null}
    >
      <MappingForm
        onSubmit={handleSubmit}
        onCancel={onClose}
        initialValues={{
          ...editMapping,
          order: editMapping ? editMapping.order : getNextOrderValue(), // Set order value
        }}
      />
    </Modal>
  );
};

export default MappingModal;
